<div class="accordions">
  <ng-content></ng-content>
</div>
